module.exports = __webpack_public_path__ + "static/bg_026_magnolia-273aca3dc54e9d2e07bcfc06b687c2c1.webp";